import LegalPage from "@/pages/legal/LegalPage";
import { CheckCircle2 } from "lucide-react";

export default function Shipping() {
  return (
    <LegalPage title="Shipping Policy" testId="page-shipping">
      <div className="not-prose bg-emerald-50 border border-emerald-200 rounded-2xl p-5 flex gap-3 items-start" data-testid="shipping-callout">
        <CheckCircle2 className="h-5 w-5 text-emerald-600 shrink-0 mt-0.5" />
        <div>
          <div className="font-display font-black text-emerald-900">Delivery is 100% digital.</div>
          <p className="text-sm text-emerald-900/80 mt-1">
            Nothing is shipped by courier, post or in physical form. There are no shipping fees, no tracking
            numbers, and no delivery addresses to confirm.
          </p>
        </div>
      </div>

      <h2>1. What you receive</h2>
      <p>
        When you buy a LeadGen plan, your deliverables are made available <strong>instantly</strong> inside your
        browser session, as:
      </p>
      <ul>
        <li>An interactive plan dashboard at a unique URL you can bookmark.</li>
        <li>A downloadable PDF of the full plan.</li>
        <li>Access to the Pro-tier sections (Meta ads, retargeting, full 30-day calendar, KPI dashboard, weekly
          checklist) if your purchased tier includes them.</li>
      </ul>

      <h2>2. When you receive it</h2>
      <p>
        Immediately after your payment is confirmed by Razorpay. Typical confirmation takes under 60 seconds. If
        you don&apos;t see the unlock within 10 minutes, email{" "}
        <a href="mailto:support@madwithppc.com">support@madwithppc.com</a> with your order ID.
      </p>

      <h2>3. Shipping fees &amp; taxes</h2>
      <p>
        No shipping or delivery fees apply because nothing is physically shipped. Applicable taxes (GST, VAT) are
        shown at checkout where required by law.
      </p>

      <h2>4. International access</h2>
      <p>
        LeadGen is accessible from anywhere there is a working internet connection, subject to local law and your
        ability to pay in a currency Razorpay supports.
      </p>

      <h2>5. Lost or missing deliveries</h2>
      <p>
        Because delivery is digital, &quot;lost in transit&quot; does not apply. If a plan is missing from your
        account due to a technical error, we will restore it or refund your purchase under the terms in our{" "}
        <a href="/refunds">Cancellation &amp; Refunds</a> page.
      </p>

      <h2>6. Contact</h2>
      <p>
        Questions about delivery? Email <a href="mailto:support@madwithppc.com">support@madwithppc.com</a>.
      </p>
    </LegalPage>
  );
}
